import { Box, Typography, Avatar, Card, CardContent, CardActions, Stack } from '@mui/material';
import { navigate } from '../../lib/navigation';
import Badge from '../../components/Badge';
import Button from '../../components/Button';

function CollaborationCard({ collab }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'flex-start' }}>
          <Avatar src={collab.brandLogoUrl} variant="rounded" sx={{ width: 56, height: 56 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6">{collab.brand}</Typography>
            <Typography color="text.secondary" gutterBottom>
              {collab.campaign}
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
              <Badge>{collab.type}</Badge>
              <Badge>{collab.status}</Badge>
            </Stack>
          </Box>
        </Stack>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant="secondary" onClick={() => navigate(`/dashboard/collaborations/${collab.id}`)}>
          View details
        </Button>
        <Button variant="secondary" onClick={() => navigate(`/dashboard/collaborations/edit/${collab.id}`)}>
          Edit
        </Button>
      </CardActions>
    </Card>
  );
}

export default CollaborationCard;
